import { render, staticRenderFns } from "./ViewOrdFreightDetail.vue?vue&type=template&id=ade19988&scoped=true"
import script from "./ViewOrdFreightDetail.vue?vue&type=script&lang=js"
export * from "./ViewOrdFreightDetail.vue?vue&type=script&lang=js"
import style0 from "./ViewOrdFreightDetail.vue?vue&type=style&index=0&id=ade19988&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade19988",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ade19988')) {
      api.createRecord('ade19988', component.options)
    } else {
      api.reload('ade19988', component.options)
    }
    module.hot.accept("./ViewOrdFreightDetail.vue?vue&type=template&id=ade19988&scoped=true", function () {
      api.rerender('ade19988', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/DeliveryOrder/ViewOrdFreightDetail.vue"
export default component.exports